import revenueReportSaga from './sagas/RevenueReportSaga';
import historyReportSaga from './sagas/HistoryReportSaga';
import statisticsReportSaga from './sagas/StatisticsReportSaga';
import statisticsForNoRevenueTicketSaga from './sagas/TripStatisticsForNoRevenueTicketSaga';
import detailStatementOfReceiptSaga from './sagas/DetailStatementOfReceiptSaga';
import tripSetTicketSaga from './sagas/TripSetTicketSaga';
export default [revenueReportSaga, historyReportSaga, statisticsReportSaga, statisticsForNoRevenueTicketSaga, tripSetTicketSaga, detailStatementOfReceiptSaga];
